import React, { useEffect, useState, Fragment } from 'react'
// component
import Wrapper from '../../common/component/Wrapper';
import AntSelect, { AntOption } from '../../common/component/AntSelect';
import { Tooltip, Icon, Radio, Checkbox, Button, Tag } from 'antd';
import DualListBox from 'react-dual-listbox';
//function common
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
//Constants
import DEFINE, { CAMPAIGN as CAMPAIGN_ENUM } from "../../../../constants/Define";
//library
import { toArray, isEqual } from 'lodash';
//css
import './PayAtHotel.less';

const CheckboxGroup = Checkbox.Group
let permisionActions = [];

const PayAtHotel = ({ ...props })=>{
    permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.PAY_AT_HOTEL);
    //useState
    const [ratePlanSelected, setRatePlanSelected] = useState([]);
    const [allRatePlan, setAllRatePlan] = useState([]);
    const [rateType, setRateType] = useState([]);
    const [filterStatus, setFilterStatus] = useState(true);
    const [hotelIds, setHotelIds] = useState([]);
    const [memberShipType, setMemberShipType] = useState([]);
    const [memberShipTypeEnum, getMemberShipTypeEnums] = useState([]);
    const [isEdit, setEdit] = useState(false);
    const [isWarning, setWarning] = useState(false);
    //hooks
    const { t, getAllHotel, hotelState, rateState, getListRatesByHotels, getPayAtHotel, updatePayAtHotel, getProfileTypes, payAtHotelState } = props;
    const { allHotels } = hotelState;
    const { isFetchingRatesByHotels, dataListRateByHotels } = rateState;
    const { payAtHotel, profileTypes, isFetching } = payAtHotelState;

    useEffect(() => {
        getAllHotel && getAllHotel();
        getPayAtHotel && getPayAtHotel();
        getProfileTypes && getProfileTypes();
    }, []);

    useEffect(()=>{
        if(profileTypes && profileTypes.length > 0){
            let tmp = profileTypes.map(item => (
                {
                    ...item,
                    label: item.profileType,
                    value: item.id
                }
            ));
            getMemberShipTypeEnums(tmp);
        }
    }, [profileTypes]);

    useEffect(()=>{
        if(Object.keys(payAtHotel).length > 0){
            loadPayAtHotelCurrent(payAtHotel);
        }
    }, [payAtHotel]);

    useEffect(() => {
        if (hotelIds && hotelIds.length > 0) {
            setRatePlanSelected([...ratePlanSelected]);
            setAllRatePlan([...dataListRateByHotels]);
        } else {
            setAllRatePlan([]);
        }
    }, [dataListRateByHotels]);

    useEffect(() => {
        if(Object.keys(payAtHotel).length > 0){
            const request = {
                hotelIds: hotelIds,
                dc: rateType,
            }
            if(filterStatus !== null) {
                request.active = filterStatus
            }
            getListRatesByHotels && getListRatesByHotels(request);
        }
    }, [hotelIds, rateType, filterStatus]);

    const loadPayAtHotelCurrent = (dataPayAthotel)=>{
        if(dataPayAthotel.hotelRatePlans && dataPayAthotel.hotelRatePlans.length > 0){
            let hotelIdsTmp = [];
            let ratePlansIdTmp = [];
            dataPayAthotel.hotelRatePlans.map(item => {
                if(item.hotelId){
                    hotelIdsTmp.push(item.hotelId);
                }
                if(item.ratePlanIds && item.ratePlanIds.length > 0){
                    item.ratePlanIds.map(rp => {
                        ratePlansIdTmp.push(`${item.hotelId}:${rp}`);
                    })
                    
                }
            })
            setHotelIds([...hotelIdsTmp]);
            setRatePlanSelected([...ratePlansIdTmp])
        }
        if(dataPayAthotel.profileTypeIds && dataPayAthotel.profileTypeIds.length > 0){
            setMemberShipType(dataPayAthotel.profileTypeIds);
        }
    }

    const onChangeHotel = (ids) => {
        setHotelIds(ids);
        if (ids && ids.length <= 0) {
            setRateType([]);
        }
    };

    const onChangeRates = (selected) => {
        setWarning(false);
        setRatePlanSelected(selected);
    };

    const onFilter = (option, filterInput) => {
        if (filterInput === '') {
            return true;
        }
        const optionText = Func.vietnameseStringToUnicode(option.label.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(filterInput.toLowerCase());
        return optionText.indexOf(inputText) >= 0 || optionText.indexOf(inputText) >= 0;
    }

    const selectFilterSearch = (input, option) => {
        const textOption = option.props?.children?.props?.children.toLowerCase() || ''
        const optionText = Func.vietnameseStringToUnicode(textOption);
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    const onChangeMemberShip = list => {
        setMemberShipType(list)
    };

    const onCancelEdit = ()=>{
        if(Object.keys(payAtHotel).length > 0){
            loadPayAtHotelCurrent(payAtHotel);
        }else{
            setHotelIds([]);
            setRatePlanSelected([]);
            setMemberShipType([]);
        }
        setEdit(false);
        setFilterStatus(true);
        setWarning(false);
    }

    const onUpdatePayAtHotel = ()=> {
        if(isEdit){
            let dataHotelRatePlans = [];
            let isPass = true;
            if(hotelIds.length > 0){
                if(ratePlanSelected.length > 0){
                    dataHotelRatePlans = hotelIds.map(hotelId => {
                        const arrRateCodes = [];
                        ratePlanSelected.map(ratePS => {
                            const arrRatePlan = ratePS.split(':');
                            if (arrRatePlan && arrRatePlan.length > 0) {
                                const hotelIdRate = arrRatePlan[0];
                                const rateCode = arrRatePlan[1];
                                if (hotelIdRate === hotelId && !arrRateCodes.includes(rateCode)) {
                                    arrRateCodes.push(rateCode);
                                }
                            }
                        })
                        return {
                            hotelId: hotelId,
                            ratePlanIds: arrRateCodes
                        }
                    });
                }else{
                    isPass = false;
                    setWarning(true);
                }
            }
            if(isPass){
                updatePayAtHotel && updatePayAtHotel({
                    hotelRatePlans: dataHotelRatePlans,
                    profileTypeIds: memberShipType,
                });
                setEdit(false);
                setFilterStatus(true);
                setWarning(false);
            }
        }else{
            setEdit(true);
        }
    }

    return (
        <Fragment>
            <HMS.PageListComponent>
                <HMS.HeaderListComponent
                    path={props.match.path}
                    groupPath={'payAtHotel'}
                    titleHeader={t('navigation.payAtHotel')}
                />
                {
                    permisionActions && permisionActions.allowCreate &&
                    <Wrapper className='col-md-12'>
                        <HMS.FormWrapperItem>
                            <Wrapper className='col-md-12 m-top-10-pay-at-hotel'>
                                <AntSelect
                                    showArrow
                                    allowClear
                                    placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.promotions.hotel")).toLowerCase()) }
                                    value={ hotelIds }
                                    onChange={ ids => {
                                        onChangeHotel(ids)
                                    } }
                                    filterOption={selectFilterSearch}
                                    style={ { width: '100%' } }
                                    className="select-types pay-at-hotel-select-hotel"
                                    mode="multiple"
                                    disabled={!isEdit}
                                >
                                    { (allHotels || []).map(hotel => (
                                        <AntOption key={ hotel.id } value={ hotel.id }>
                                            <Tooltip title={ hotel.name } placement="topLeft">{ `${ hotel.code } - ${ hotel.name }` }</Tooltip>
                                        </AntOption>
                                    )) }
                                </AntSelect>
                            </Wrapper>
                            <Wrapper className='col-md-6 m-top-10-pay-at-hotel'>
                                <div className="d-flex filter-pay-at-hotel">
                                    <span className="label-filter-pay-at-hotel">
                                        {t(`item.campaign.filterStatus`)}:
                                    </span>
                                    <Radio.Group 
                                        value={filterStatus}
                                        onChange={e => setFilterStatus(e.target.value)}
                                        disabled={allRatePlan.length === 0 }
                                    >
                                        <Radio key={0} value={true}>{t(`item.campaign.active`)}</Radio>
                                        <Radio key={1} value={false}>{t(`item.campaign.deactive`)}</Radio>
                                        <Radio key={2} value={undefined}>{t(`item.campaign.all`)}</Radio>
                                    </Radio.Group>
                                </div>
                            </Wrapper>
                            <Wrapper className='col-md-6 m-top-10-pay-at-hotel'>
                                <div className="d-flex filter-pay-at-hotel right">
                                    <span className="label-filter-pay-at-hotel">
                                        {t(`item.payAtHotel.configMemberShiptype`)}:
                                    </span>
                                    <CheckboxGroup
                                        className="pay-at-hotel-member-ship-type"
                                        disabled={!isEdit}
                                        options={ memberShipTypeEnum }
                                        value={ memberShipType }
                                        onChange={ onChangeMemberShip }/>
                                </div>
                            </Wrapper>
                            <Wrapper className='col-md-12'>
                                <HMS.LoadingComponent spinning={ isFetchingRatesByHotels }>
                                    <div className='dual-list-apply-hotel'>
                                        <DualListBox
                                            canFilter
                                            filterPlaceholder={ t('action.search') }
                                            filterCallback={ onFilter }
                                            options={
                                                (allRatePlan || []).map(item => (
                                                    {
                                                        label: item.name,
                                                        options: item.ratePlans.map(itemRate => ({
                                                            ...itemRate,
                                                            label: itemRate.code,
                                                            value: `${ item.id }:${ itemRate.refId }`,
                                                        })),
                                                    }))
                                            }
                                            selected={ [...ratePlanSelected] }
                                            onChange={ onChangeRates }
                                            icons={ {
                                                moveLeft: <Icon type="left" className="mx-2"/>,
                                                moveAllLeft: <Icon type="double-left" className="mx-2"/>,
                                                moveRight: <Icon type="right" className="mx-2"/>,
                                                moveAllRight: <Icon type="double-right" className="mx-2"/>,
                                            } }
                                            disabled={ !isEdit || !allRatePlan || (allRatePlan && allRatePlan.length <= 0) }
                                        />
                                    </div>
                                </HMS.LoadingComponent>
                            </Wrapper>
                            <Wrapper className="col-md-12 btn-pay-at-hotel-edit">
                                { isWarning && <span className="warning-empty-rate-plan">{t('item.payAtHotel.emptyRatePlan')}</span>}
                                { isEdit && <Button style={{marginRight: 10}} onClick={onCancelEdit}>{t(`item.payAtHotel.cancel`)}</Button> }
                                <Button loading={isFetching} type="primary" onClick={onUpdatePayAtHotel}>{t(`item.payAtHotel.${isEdit ? 'save' : 'update'}`)}</Button>
                            </Wrapper>
                        </HMS.FormWrapperItem>
                    </Wrapper>
                }
            </HMS.PageListComponent>
        </Fragment>
    );
}

export default PayAtHotel;
